import ModalHeading from '../../../../../components/shared/modal-heading';
import React from 'react';
import { RxCross2 } from 'react-icons/rx';

const PositionViewModal = ({ positions, onClose }) => {
    // Safely extract and limit to first 10 positions
    const positionArray = Object.values(positions?.vehicle || {}).slice(0, 10);

    return (
        <div className="w-full">
            <div className="w-full pb-2 pl-4 border-b relative">
                <ModalHeading className="text-left">Tire Positions</ModalHeading>
                <button
                    className="hover:scale-105 absolute -top-2 right-3 bg-white border p-2 rounded-full"
                    onClick={onClose}
                >
                    <RxCross2 className="text-xl" />
                </button>
            </div>

            <div className="flex flex-col gap-2 px-5 py-2">
                {positionArray.map((pos, i) => (
                    <div key={i} className="flex items-center gap-4 text-gray-700 text-sm">
                        <h1 className="w-10 ">{pos.id} :</h1>
                        <p className="">{pos.label}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PositionViewModal;
